import { Stack } from '@chakra-ui/react';
import { OcrCardViewModel } from '@diamond/sol-buyer/utils';

import { getOcrManualFieldIndex } from './ocr-staging';
import { OcrPreviewCard } from './OcrPreviewCard';

interface OcrStagedCardsProps {
  bankFieldLabel?: string;
  cards: OcrCardViewModel[];
  deletingId: string | null;
  gap?: number;
  layout?: 'stack' | 'row';
  manualOverrides: Array<{ ocr_job_id?: string } | null | undefined>;
  mt?: number | string;
  onDelete: (id: string) => Promise<void> | void;
  w?: string;
}

export const OcrStagedCards = ({
  bankFieldLabel,
  cards,
  deletingId,
  gap = 4,
  layout = 'stack',
  manualOverrides,
  mt,
  onDelete,
  w,
}: OcrStagedCardsProps) => {
  if (cards.length === 0) {
    return null;
  }

  return (
    <Stack gap={gap} mt={mt} w={w}>
      {cards.map((card, index) => {
        const fieldIndex = getOcrManualFieldIndex(
          cards,
          index,
          manualOverrides
        );

        return (
          <OcrPreviewCard
            key={card.item.id}
            bankFieldLabel={bankFieldLabel}
            fieldIndex={fieldIndex}
            isDeleting={deletingId === card.item.id}
            item={card.item}
            layout={layout}
            state={card.state}
            onDelete={() => onDelete(card.item.id)}
          />
        );
      })}
    </Stack>
  );
};
